/**
 * yt-cart-gifts.js — one free gift per basket, not one per blend.
 *
 * Every blend's bundle carries the £0 "Yutrients Weighing Spoons" line, and
 * every line is stamped with that blend's `_yt_formula`. Shopify will not merge
 * two lines of the same variant when their properties differ, so a basket with
 * three blends showed three identical free spoons — "tons of duplicate free
 * shipping", 12 Oct 2026. A real abandoned basket on 8 Oct carried three.
 *
 * This collapses them after the fact, which covers every add path (quick-add,
 * base PDP, bundle PDP, BYO, the drawer's own re-mint) and heals baskets built
 * before the fix.
 *
 * A gift is a line that is free AND not on a selling plan. The £15
 * Manufacturing & Lab Fee is neither — it is charged, and it is legitimately
 * one per blend — so it is never touched.
 */
(function () {
  'use strict';
  if (window.ytDedupeGifts) return;

  var running = null;

  window.ytDedupeGifts = function () {
    if (running) return running;
    running = (async function () {
      try {
        var cart = await (await fetch('/cart.js', {
          credentials: 'same-origin', headers: { Accept: 'application/json' },
        })).json();
        var items = cart.items || [];
        var seen = {};
        var updates = {};
        items.forEach(function (i) {
          if (i.price !== 0) return;              // charged lines are never gifts
          if (i.selling_plan_allocation) return;  // a blend, not a gift
          var key = String(i.variant_id);
          if (seen[key]) {
            updates[i.key] = 0;                   // a second copy: drop the line
          } else {
            seen[key] = true;
            if (i.quantity > 1) updates[i.key] = 1;
          }
        });
        // 15 Oct 2026 (order #1303: five identical Rest-ezy groups, £174.75).
        // Two bundle groups whose lines are the same variants on the same
        // plans at the same quantities are the same blend added twice — by a
        // second visit, a retried press, an old link. Keep the newest group
        // (Shopify prepends, so the first seen) and drop the rest. Groups
        // that differ in any line are different blends and are left alone.
        var groups = {}; var order = [];
        items.forEach(function (i) {
          var k = i.properties && i.properties._rc_bundle;
          if (!k) return;
          if (!groups[k]) { groups[k] = []; order.push(k); }
          groups[k].push(i);
        });
        var signatures = {};
        order.forEach(function (k) {
          var sig = groups[k].map(function (i) {
            return i.variant_id + ':' + (i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.id : 'ot') + ':' + i.quantity;
          }).sort().join('|');
          if (signatures[sig]) { groups[k].forEach(function (i) { updates[i.key] = 0; }); }
          else { signatures[sig] = k; }
        });
        if (!Object.keys(updates).length) return false;
        await fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates }),
        });
        return true;
      } catch (_e) {
        return false;
      } finally {
        running = null;
      }
    })();
    return running;
  };
})();
